/*==========================*/
/* imagesLoaded plugin */
/*==========================*/

/*
 * jQuery imagesLoaded plugin v2.0.1
 * http://github.com/desandro/imagesloaded
 *
 * MIT License. by Paul Irish et al.
 */

(function(c,n){var k="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";c.fn.imagesLoaded=function(l){function m(){var b=c(h),a=c(g);d&&(g.length?d.reject(e,b,a):d.resolve(e));c.isFunction(l)&&l.call(f,e,b,a)}function i(b,a){b.src===k||-1!==c.inArray(b,j)||(j.push(b),a?g.push(b):h.push(b),c.data(b,"imagesLoaded",{isBroken:a,src:b.src}),o&&d.notifyWith(c(b),[a,e,c(h),c(g)]),e.length===j.length&&(setTimeout(m),e.unbind(".imagesLoaded")))}var f=this,d=c.isFunction(c.Deferred)?c.Deferred():
0,o=c.isFunction(d.notify),e=f.find("img").add(f.filter("img")),j=[],h=[],g=[];e.length?e.bind("load.imagesLoaded error.imagesLoaded",function(b){i(b.target,"error"===b.type)}).each(function(b,a){var e=a.src,d=c.data(a,"imagesLoaded");if(d&&d.src===e)i(a,d.isBroken);else if(a.complete&&a.naturalWidth!==n)i(a,0===a.naturalWidth||0===a.naturalHeight);else if(a.readyState||a.complete)a.src=k,a.src=e}):m();return d?d.promise(f):f}})(jQuery);


$(function(){

/*==========================*/
/* Global Variables */
/*==========================*/

var   THE_BODY              = $('body'),
      HEADER                = $('#header'),
      FOOTER                = $('#footer'),
      IS_INDEX              = (THE_BODY.hasClass('template-index')) ? true : false,
      IS_COLLECTION         = (THE_BODY.hasClass('template-collection')) ? true : false,
      IS_COLLECTION_LISTING = ($('#collection-list').length > 0) ? true : false,
      IS_PRODUCT            = (THE_BODY.hasClass('template-product')) ? true : false,
      IS_BLOG               = (THE_BODY.hasClass('template-blog')) ? true : false,
      IS_ARTICLE            = (THE_BODY.hasClass('template-article')) ? true : false,
      IS_SEARCH             = (THE_BODY.hasClass('template-search')) ? true : false,
      IS_CART               = (THE_BODY.hasClass('template-cart')) ? true : false,
      HAS_LOGO              = (HEADER.hasClass('use-logo')) ? true : false,
      BE_WIDE               = (HEADER.hasClass('wide')) ? true : false,
      HAS_CURRENCIES        = (HEADER.hasClass('currencies')) ? true : false,
      HAS_TWITTER           = (FOOTER.hasClass('has-twitter')) ? true : false,
   /*   IS_IE                 = ($.browser.msie) ? true : false,*/
      PRODUCT_IMAGE_W_TO_H_RATIO = product_image_w_to_h_ratio || 1,
      THREE_PER_ROW_W       = 268,
      FOUR_PER_ROW_W        = 191,
      THREE_PER_ROW_H       = parseInt(THREE_PER_ROW_W/PRODUCT_IMAGE_W_TO_H_RATIO,  10),
      FOUR_PER_ROW_H        = parseInt(FOUR_PER_ROW_W/PRODUCT_IMAGE_W_TO_H_RATIO,   10);

$('html').removeClass('no-js');


/* Global JS */
/*==========================*/

/* loadImages function */
/* elems are the images, and ch is the container height */
/* Sizes image appropriately to fill as much of the container as possible
   without cropping it, and making sure the image is vertically aligned */
var loadImages = function(elems, ch) {

    $(elems).each(function(){
        $(this).imagesLoaded( function() {
            var i_w = $(this).width();  // image width
            var i_h = $(this).height(); // image height
            var c_h = ch;               // container height
            var v_o = (c_h - i_h) / 2;  // vertical offset            
            if ( i_h > c_h ) {
                $(this).css('height',ch).css('width','auto');
            } else {
                $(this).css('margin-top',v_o);
            }   
            $(this).fadeTo(200,1); // reveals image with a 200 ms-lomg fade-in.
        });
    });
}

/* Snippet JS */
/*==========================*/

/* Additional Products */
loadImages('.related-products-list img',FOUR_PER_ROW_H);

/* Layout JS */
/*==========================*/


/* Handle Cart Total */


/* Index JS */
/*==========================*/

if (IS_INDEX) {

} // END of IS_INDEX

/* Collection JS */
/*==========================*/
if (IS_COLLECTION || IS_CART || IS_SEARCH) {

} // END of IS_COLLECTION

/* Collection Listing JS */
/*==========================*/
if (IS_COLLECTION_LISTING) {

} // END of IS_COLLECTION_LISTING


/* Product JS */
/*==========================*/
if (IS_PRODUCT) {
var product_container = $('#product-photo-container');      
    // Initialize first photo
    product_container.find('img:first').imagesLoaded(function(){
        var elem = $(this);
        elem.addClass('active').fadeIn(100);
        //product_container.css('height',elem.height());
        //elem.parent().css( {'height':elem.height(), 'width':elem.width()} );
    });

    // Display new photo
    $('.product-photo-thumb').click(function(){
        
        var active_index = $(this).index();
        var photo_to_show = product_container.find('img').eq(active_index);
        var photo_to_hide = product_container.find('.active');

        photo_to_hide.fadeOut(100, function(){
            photo_to_hide.removeClass('active');
            photo_to_hide.parent().css( {'height':0, 'width':0} );
            var photo_to_show = product_container.find('img').eq(active_index);
            photo_to_show.imagesLoaded(function(){
                product_container.animate({height:photo_to_show.height()},200,function(){
                    photo_to_show.fadeIn(100, function(){
                        $(this).addClass('active');
                        $(this).addClass('img-responsive');
                        $(this).parent().css( {'height':$(this).height(), 'width':$(this).width()} );
                    });
                });
            });
        });

    }); 

} // END of IS_PRODUCT


/* Placeholder JS */
/*==========================*/

$('[placeholder]').each(function(){
    if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
    }
});

$('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
    }
}).blur(function() {
    if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
    }
});                    

/* Form validation JS */
/*==========================*/

$('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
});

$('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
        $(this).val('').removeClass('hint');
    });
    return true;
});

/* Cart.liquid */
/*==========================*/
                    
                    
if (IS_CART) {
    
    /* This auto-saves cart attribute and cart note.
       This will save quantity edits too.
       See this: http://wiki.shopify.com/Ask_customer_for_additional_information#My_clients_fill_up_the_cart_attributes.2C_but_they_are_not_saved._When_they_leave_the_cart_page_and_come_back.2C_the_boxes_previously_filled-up_are_empty._How_can_I_fix_this.3F */

    $(window).unload(function() {
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: $('form[action="/cart"]').serialize(),
            dataType: 'json',
            async: false
        };
        $.ajax(params);
    });

	$('.update_icon').click(function() {
     //$('#cartform').submit();
      $(this).parents("form").submit();
	});
}

/* Multiple currencies */
/*==========================*/

if (HAS_CURRENCIES) {
    

}

/* Tooltip */
/*==========================*/

	//$('.tooltip').tooltip();
	//$('.tooltip-2').tooltip();
  

/* Open all external + PDF download links in a new browser tab */

$('a[href^="http"]')
  .not('a[href^="' + shop_url + '"]')
  .not('a[href^="http://static.shopify.com"]')
  .not('a[href^="http://cdn.shopify.com"]')
  .not('.lightbox')
  .attr('target', '_blank');

});


$(window).resize(function() {
  if ($(window).width() < 768) {     
    $( ".dropdown a" ).addClass( "dropdown-toggle" );
    $(".dropdown > a").attr("data-toggle","dropdown");  
    $("#md-powered").hide();
    $("#xs-powered").show();     
    $("#md-product-title").hide();
    $("#xs-product-title").show();


    // accordition

    setTimeout(function(){       
      $('#bc-sf-filter-tree-mobile-button').click(function(){ 
        if($("#bc-sf-filter-tree-mobile-button").parents("#bc-sf-filter-tree-mobile").find(".bc-sf-filter-tree-mobile-open")){
          console.log("outer if..");
          if($("#collapseOne").parents("#category_accordion").find(".collapse.in")){             
            $("#collapseOne").parents("#category_accordion").find(".collapse.in").removeClass("in").attr("aria-expanded","false");
            $(".card-header .accordion-title").attr("aria-expanded","false");
          }
        }         
      });

      $('.card-header .accordion-title').click(function(){         
        if($("#collapseOne").parents("#category_accordion").find(".collapse.in")){
          if($("#bc-sf-filter-tree-mobile-button").parents("#bc-sf-filter-tree-mobile").find(".bc-sf-filter-tree-mobile-open")){
            console.log("2nd outer if..");
            $("#bc-sf-filter-tree-mobile-button").removeClass("bc-sf-filter-tree-mobile-button-open");
            $("#bc-sf-filter-wrapper").find("#bc-sf-filter-tree").hide();             
          }
        }

      });
    }, 3000);


  }       
  else{
  /*  $('.navbar .dropdown').hover(function() {
      $(this).find('.dropdown-menu').first().stop(true, true).slideDown(150);
    }, function() {

      $(this).find('.dropdown-menu').first().stop(true, true).slideUp(105);
    }); */ 
    /* OLD SCRIPT
    $(".navbar-nav .nav-item.lvl-1").mouseover(function(){
      $(this).addClass("open");
    });
    $(".navbar-nav .nav-item.lvl-1").mouseout(function(){
		$(this).removeClass("open");
    });*/
     $(".is-moved-by-drawer").mouseover(function(){
		$(".navbar-nav .nav-item.lvl-1").removeClass("open");
    });
    
    $(".navbar-nav .nav-item.lvl-1").mouseover(function(){
      $(this).addClass("open");
    });


     $(".item-1").mouseover(function(){
      $(".item-1.nav-item.lvl-1").addClass("open");
       $(".item-2.nav-item.lvl-1").removeClass("open");
       $(".item-4.nav-item.lvl-1").removeClass("open");
    });
       $(".item-2").mouseover(function(){
       $(".item-1.nav-item.lvl-1").removeClass("open");
         $(".item-4.nav-item.lvl-1").removeClass("open");
    });
        $(".item-3").mouseover(function(){
       $(".nav-item.lvl-1").removeClass("open");
    });
        $(".item-4").mouseover(function(){
       $(".item-1.nav-item.lvl-1").removeClass("open");
          $(".item-2.nav-item.lvl-1").removeClass("open");
    });
      $(".item-5").mouseover(function(){
       $(".nav-item.lvl-1").removeClass("open");
    });
    
    $("#md-powered").show();
    $("#xs-powered").hide();     
    $("#md-product-title").show();
    $("#xs-product-title").hide();
  }
    }).resize();
    


/********** END MMenu *************/



